// src/components/CustomerSummary/Constants/sectionLabels.js
// ============================================================================
// BLOCK CS.CONST.L1 — Section labels
// ----------------------------------------------------------------------------
// PURPOSE
// - Human-readable titles for section cards.
// - Keys not listed fall back to the raw key in SectionsPanel.
// ============================================================================

const SECTION_LABELS = {
  studiesStarted: 'Studies Started',
  studiesStartedWorkflowDistribution: 'Studies Started Workflow Distribution',

  finalizedStudies: 'Finalized Studies',
  finalizedStudiesWorkflowDistributions: 'Finalized Studies Workflow Distributions',

  urgentEmergentNotifications: 'Urgent / Emergent Notifications (MDN)',

  turnaroundTimes: 'Turnaround Times',
  averageStudyLength: 'Average Study Length',
  deviceUtilization: 'Device Utilization',

  // Final report sections
  supportTicketsResolved: 'Support Tickets Resolved',
  top3StudyIndications: 'Top 3 Study Indications',
  top3OrderingProviders: 'Top 3 Ordering Providers',
  payerMix: 'Payer Mix',
  patientStats: 'Patient Stats',
};

export default SECTION_LABELS;
